<template>
	<div class="s-gray-bg" style="min-height:100vh;">
		<div class="p-space-between p-box-center-y p-margin30 p-line-height3 p-font1 p-color1 p-bold p-padding-top10">
			<span>{{ day.substring(0,4)+$t('common.yearUnit')+day.substring(5,7)+$t('common.monthUnit')+day.substring(8,10)+$t('common.dayUnit')+' '+$t('common.detail')}}</span>
		</div>

		<ul class="p-margin20 p-padding20  p-white-bg p-radius20 p-black " style="width: auto;"
			v-if="Object.keys(nibpDayListData.dayListJson).length>0">
			<template>
				<div v-for="(v,k,i) in nibpDayListData.dayListJson" :key="k" >
					<div @click="goToDayDataDetail(v)">
						<!-- <div>{{  JSON.stringify(v)  }}</div> -->
						<div class="p-space-between p-box-center-y p-padding-top10" >
							<img :src="checkAbnormal(v,'BP',this).isNormal ? require('@/assets/img/nibp_list_normal.png') : require('@/assets/img/nibp_list_abnormal.png')"
								class="p-margin-left10 " style="width:0.8rem; height:0.8rem;padding-bottom: 0.8rem;" />
							<span class="p-space-between p-box-center-y p-border2 p-color6-border  "
								:class="k===(nibpDayListData.dayListJson.length-1)?'p-border-none':''"
								style="width:calc(100% - 1.2rem - 0.8rem); padding:0.3rem 0rem 1rem 0rem;">

								<div class="p-space-between p-box-center-y p-font0-8">
									<div class="p-font1-4">
										{{ v.sys+'/'+v.dia  }}
									</div>
									<span class="p-color3" style="margin-left: 0.2rem;margin-top: 0.2rem;">{{ $t('measure.mmHg') }}</span>
								</div>


								<div class="p-space-between p-box-center p-font0-8"
									style="width: 30%;text-align: center;">
									<span
										:class="[  checkAbnormal(v,'BP').isNormal ? 's-green' : 'p-red'  ]">{{ checkAbnormalLanguageCustom(v,"BP",this).info  }}
									</span>

								</div>

								<div class="p-font0-9 p-color3">
									<!-- <div class="p-font1 p-color1">血压：{{ v.sys  }}/{{ v.dia  }} {{ v.result  }}<text class="p-color3">mmHg</text></div> -->
									{{ time(v.sts).format('HH:mm:ss')  }}
								</div>
								<img src="../assets/img/arrow_gray_right.png"/>
							</span>
						</div>
					</div >

				</div>
			</template>
		</ul>
		<loadingContent v-if="nibpDayListData.isLoading"></loadingContent>
		<noContent v-else-if="(!nibpDayListData.isLoading) && nibpDayListData.isNoData"></noContent>
	</div>
</template>

<script>
	import loadingContent from "../components/loading/loadingContent";
	import noContent from "../components/loading/noContent";
	import loadedAllData from "../components/loading/loadedAllData";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		jsonToParams,
		getCalorie,
		arrGroup,
		checkAbnormal,
		checkAbnormal2,
		checkAbnormal3,
		checkAbnormalLanguage
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loadingContent,
			noContent,
			loadedAllData,
		},
		data() {
			return {
				title: '',
				day: '',
			}
		},
		methods: {
			checkAbnormal,
			checkAbnormalLanguage,
			checkAbnormalLanguageCustom(json, type){
				return checkAbnormalLanguage(json, type,this);
			},
			goToDayDataDetail(value){
				this.$router.push({
				    path: '/bloodPressureDayDetail',
				    query: {
				      pid: this.$route.query.pid,
					  dayData: value,
					  language:this.$route.query.language
				    }
				  })
			},
			// 获取不同类型数据
			getData() {
				this.getNewReportDayData(this.day);
			},

		},
		created() {
		
		
			this.day=this.$route.query.day;
		 
			document.title = this.day.substring(0,4)+this.$t('common.yearUnit')+this.day.substring(5,7)+this.$t('common.monthUnit')+this.day.substring(8,10)+this.$t('common.dayUnit')+this.$t('common.detail')
			console.log("created this.day: ", this.day);
			this.getData();
		},
	}
</script>

<style scoped>

</style>
